import React, { Component } from 'react';
import { motion } from 'framer-motion';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-primary flex items-center justify-center text-right px-4">
          <div className="absolute inset-0 pointer-events-none z-0">
            <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-secondary/[0.02] rounded-full blur-[120px]" />
            <div className="absolute bottom-1/4 right-1/4 w-[350px] h-[350px] bg-primary-light/20 rounded-full blur-[140px]" />
          </div>

          <div className="relative z-10 max-w-lg w-full text-center">
            <div className="w-full relative">
              {/* Custom Animated Disconnected Plug SVG */}
              <div className="w-full flex justify-center mb-6">
                <svg className="w-32 h-32 text-secondary" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Left Plug (Male) */}
                  <motion.g 
                    animate={{ x: [-2, -8, -2] }}
                    transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
                  >
                    <path d="M25 42H37V58H25V42Z" fill="currentColor" fillOpacity="0.85"/>
                    <path d="M37 45H47V47H37V45Z" fill="#C9A227"/>
                    <path d="M37 53H47V55H37V53Z" fill="#C9A227"/>
                    <path d="M25 50C18 50 14 43 5 43" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                  </motion.g>

                  {/* Right Socket (Female) */}
                  <motion.g
                    animate={{ x: [2, 8, 2] }}
                    transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
                  >
                    <path d="M68 38H56V62H68V38Z" fill="currentColor"/>
                    <circle cx="61" cy="45" r="2.5" fill="var(--color-primary)"/>
                    <circle cx="61" cy="55" r="2.5" fill="var(--color-primary)"/>
                    <path d="M68 50C75 50 82 57 95 57" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                  </motion.g>

                  {/* Sparks in the middle gap */}
                  <motion.g
                    animate={{ opacity: [0.1, 1, 0.1, 0.9, 0.1] }}
                    transition={{ repeat: Infinity, duration: 1.2 }}
                  >
                    <path d="M49 44L53 39" stroke="#C9A227" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M51 50L55 50" stroke="#C9A227" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M49 56L53 61" stroke="#C9A227" strokeWidth="2" strokeLinecap="round"/>
                  </motion.g>
                </svg>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-light mb-4 font-serif">
                حدث <span className="text-secondary italic">خطأ غير متوقع!</span>
              </h2>

              <p className="text-accent-muted text-sm leading-relaxed mb-8 max-w-sm mx-auto font-light">
                عذراً، حدث خطأ فني غير متوقع أثناء تحميل محتوى الصفحة. نرجو منك محاولة إعادة تحميل الصفحة أو العودة للقائمة الرئيسية.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={() => window.location.reload()}
                  className="px-8 py-3.5 rounded-xl bg-gradient-to-r from-secondary to-secondary-light text-primary font-bold hover:opacity-95 transition-all duration-300 shadow-lg shadow-secondary/15 flex items-center justify-center gap-2 text-sm"
                >
                  <i className="fas fa-arrows-rotate" />
                  <span>إعادة تحميل الصفحة</span>
                </button>
                
                <a
                  href="/"
                  className="px-8 py-3.5 rounded-xl border border-secondary/20 bg-secondary/5 text-light hover:bg-secondary/10 hover:border-secondary/40 transition-all duration-300 flex items-center justify-center gap-2 text-sm"
                >
                  <i className="fas fa-home text-secondary" />
                  <span>العودة للرئيسية</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
